import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddContactInfoRequest } from '@/types/entities/contactInfo';
import { AddAddressRequest } from '@/domains/addresses/types/api/requests/AddAddressRequest';
import { ProducerEntityType } from '@/domains/producers/types/ProducerEntityType';

const producerSlice = createSlice({
  name: 'producer',
  initialState: {},
  reducers: {
    addProducerAddress: (
      _,
      _action: PayloadAction<AddAddressRequest & { producerEntityType: ProducerEntityType }>,
    ) => {},
    addProducerContactInfo: (
      _,
      _action: PayloadAction<AddContactInfoRequest & { producerEntityType: ProducerEntityType }>,
    ) => {},
  },
});

export const { addProducerAddress, addProducerContactInfo } = producerSlice.actions;

export const producerReducer = producerSlice.reducer;
export const producerReducerPath = producerSlice.reducerPath;
